export default "__VITE_ASSET__BS8OPwxU__"